// src/Homepage.js
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

// --- API Configuration (Matched to Sidebar) ---
const API_BASE = (process.env.REACT_APP_API_BASE || "/api").replace(/\/+$/, "");

// --- Icons ---
const Icons = {
  Project: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-geo-alt-fill" viewBox="0 0 16 16">
      <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10zm0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"/>
    </svg>
  ),
  Calendar: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-calendar-event" viewBox="0 0 16 16">
      <path d="M11 6.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1z"/>
      <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/>
    </svg>
  ),
  Ndvi: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-flower1" viewBox="0 0 16 16">
      <path d="M6.174 1.184a2 2 0 0 1 3.652 0l.348 1.044c.15.452.483.815.918 1.002l1.018.437a2 2 0 0 1 0 3.666l-1.018.437a2.035 2.035 0 0 0-.918 1.002l-.348 1.044a2 2 0 0 1-3.652 0l-.348-1.044a2.035 2.035 0 0 0-.918-1.002l-1.018-.437a2 2 0 0 1 0-3.666l1.018-.437a2.035 2.035 0 0 0 .918-1.002l.348-1.044zm2.863 1.057a1 1 0 0 0-2.074 0l-.348 1.044a3.036 3.036 0 0 1-1.37 1.495l-1.018.437a1 1 0 0 0 0 2.166l1.018.437a3.036 3.036 0 0 1 1.37 1.495l.348 1.044a1 1 0 0 0 2.074 0l.348-1.044a3.036 3.036 0 0 1 1.37-1.495l1.018-.437a1 1 0 0 0 0-2.166l-1.018-.437a3.036 3.036 0 0 1-1.37-1.495l-.348-1.044z"/>
    </svg>
  ),
  Lidar: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-layers-half" viewBox="0 0 16 16">
      <path d="M8.235 1.559a.5.5 0 0 0-.47 0l-7.5 4a.5.5 0 0 0 0 .882L3.188 8 .264 9.559a.5.5 0 0 0 0 .882l7.5 4a.5.5 0 0 0 .47 0l7.5-4a.5.5 0 0 0 0-.882L12.813 8l2.922-1.559a.5.5 0 0 0 0-.882l-7.5-4zM8 9.433 1.562 6 8 2.567 14.438 6 8 9.433z"/>
    </svg>
  ),
  Cube: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-box" viewBox="0 0 16 16">
      <path d="M8.186 1.113a.5.5 0 0 0-.372 0L1.846 3.5 8 5.961 14.154 3.5 8.186 1.113zM15 4.239l-6.5 2.6v7.922l6.5-2.6V4.24zM7.5 14.762V6.838L1 4.239v7.923l6.5 2.6zM7.443.184a1.5 1.5 0 0 1 1.114 0l7.129 2.852A.5.5 0 0 1 16 3.5v8.662a1 1 0 0 1-.629.928l-7.185 2.874a.5.5 0 0 1-1.114 0L.629 13.09a1 1 0 0 1-.63-.928V3.5a.5.5 0 0 1 .314-.464L7.443.184z"/>
    </svg>
  ),
  Camera: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-camera" viewBox="0 0 16 16">
      <path d="M15 12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h1.172a3 3 0 0 0 2.12-.879l.83-.828A1 1 0 0 1 6.827 3h2.344a1 1 0 0 1 .707.293l.828.828A3 3 0 0 0 12.828 5H14a1 1 0 0 1 1 1v6zM2 4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1.172a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 9.172 2H6.828a2 2 0 0 0-1.414.586l-.828.828A2 2 0 0 1 3.172 4H2z"/>
      <path d="M8 11a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5zm0 1a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zM3 6.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z"/>
    </svg>
  )
};

// Helper: Date formatter
function formatSurveyLabel(raw) {
  if (!raw) return "No Date Selected";
  try {
    if (typeof raw === "string" && /^\d{4}-\d{2}-\d{2}$/.test(raw)) {
      const [y, m, d] = raw.split("-");
      const dateObj = new Date(y, m - 1, d);
      return dateObj.toLocaleDateString("en-US", { year: 'numeric', month: 'long', day: 'numeric' });
    }
    const d = new Date(raw);
    if (!isNaN(d.getTime())) return d.toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" });
    return String(raw);
  } catch {
    return String(raw);
  }
}

// Helper: Basic JWT Decode
function decodeJwt(token) {
  try {
    const payload = token.split(".")[1];
    const json = atob(payload.replace(/-/g, "+").replace(/_/g, "/"));
    return JSON.parse(decodeURIComponent(escape(json)));
  } catch {
    return null;
  }
}

function Homepage() {
  const navigate = useNavigate();
  const [info, setInfo] = useState({ name: "", email: "", role: "", organization: "" });
  const [lastProject, setLastProject] = useState({ name: "", date: "" });
  
  // New State: Hold the full survey object (so we can get the ID)
  const [activeSurveyDetails, setActiveSurveyDetails] = useState(null);

  // 1. Initial Load: User Info & LocalStorage Project
  useEffect(() => {
    const token = localStorage.getItem("token") || "";
    const nameLS = localStorage.getItem("name") || "";
    const orgLS = localStorage.getItem("userOrganization") || localStorage.getItem("organization") || "";
    let email = localStorage.getItem("rememberEmail") || "";
    let role = "";

    const decoded = token ? decodeJwt(token) : null;
    if (decoded) {
      email = decoded.email || email;
      role = decoded.role || "";
    }

    setInfo({
      name: nameLS || (email ? email.split("@")[0] : "User"),
      email: email || "",
      role,
      organization: orgLS,
    });

    const locName = localStorage.getItem("location_name");
    const surveyTime = localStorage.getItem("survey_time");

    if (locName) {
      setLastProject({
        name: locName.trim(),
        date: surveyTime
      });
    }
  }, []);

  // 2. Background Fetch: Get the real Survey ID for the resumed project
  useEffect(() => {
    if (!lastProject.name) return;

    const fetchDetails = async () => {
      try {
        const org = localStorage.getItem("organization") || "";
        const token = localStorage.getItem("token");
        
        // Fetch surveys for the organization
        let url = `${API_BASE}/survey_request?organization=${encodeURIComponent(org)}`;
        
        const res = await fetch(url, { 
            headers: token ? { Authorization: `Bearer ${token}` } : {} 
        });
        
        if (!res.ok) return;
        
        const data = await res.json();
        const rows = Array.isArray(data) ? data : (data.survey || []);

        // Find match: Location Name + Survey Time
        const match = rows.find(r => {
            const rLoc = (r.location_name || r.location || "").trim();
            
            // Normalize dates to YYYY-MM-DD for comparison
            let rDate = r.survey_time || r.survey_date || "";
            if(rDate && typeof rDate === 'string' && rDate.includes('T')) {
                rDate = rDate.split('T')[0];
            }
            
            return rLoc === lastProject.name && rDate === lastProject.date;
        });

        // If no specific date match, try finding the LATEST for that location
        if (!match && rows.length > 0) {
             const locMatches = rows.filter(r => (r.location_name || r.location || "").trim() === lastProject.name);
             if (locMatches.length > 0) {
                 // Sort by date descending
                 locMatches.sort((a, b) => new Date(b.survey_time) - new Date(a.survey_time));
                 setActiveSurveyDetails(locMatches[0]);
                 return;
             }
        }

        if (match) {
            setActiveSurveyDetails(match);
        }
      } catch (e) {
        console.error("Error fetching survey details for resume:", e);
      }
    };

    fetchDetails();
  }, [lastProject]);

  const logout = () => {
    localStorage.removeItem("token");
    window.location.href = "/";
  };

  // 3. Navigation Handler: Constructs correct URL /map/Name?_s=ID
  const handleResume = (e) => {
    e.preventDefault();
    if (!lastProject.name) return;

    // Determine ID: Use fetched ID, fallback to Date.now() if API failed
    const uniqueId = activeSurveyDetails?.id ?? activeSurveyDetails?._id ?? Date.now();
    
    // Encode path components
    const routeKey = encodeURIComponent(lastProject.name);
    
    // Construct the specific URL you requested
    const url = `/map/${routeKey}?_s=${uniqueId}`;

    // Payload for state transfer (keeps map sync without needing to re-fetch immediately)
    const payload = {
        location_name: lastProject.name,
        survey_time: lastProject.date,
        organization: info.organization,
        from: "homepage",
        ...activeSurveyDetails // Pass full object if available
    };

    // Sync SessionStorage (critical for Sidebar sync)
    try { 
        sessionStorage.setItem("survey-selected-payload", JSON.stringify(payload)); 
    } catch (err) { /* ignore */ }

    // Dispatch Event (updates Sidebar immediately)
    try { 
        window.dispatchEvent(new CustomEvent("survey-selected", { detail: payload })); 
    } catch (err) { /* ignore */ }

    // Navigate
    navigate(url, { state: payload });
  };

  return (
    <div className="min-vh-100 d-flex flex-column bg-light">
      
      {/* Topbar */}
      <nav className="navbar navbar-light bg-white border-bottom sticky-top">
        <div className="container-fluid">
          <span className="navbar-brand mb-0 h1">Homepage</span>
          <div className="d-flex align-items-center gap-3">
            {info.email && <span className="text-muted small">{info.email}</span>}
            <button className="btn btn-outline-danger btn-sm" onClick={logout}>
              Logout
            </button>
          </div>
        </div>
      </nav>

      {/* Main Content */}
      <main className="container my-5 flex-grow-1">
        
        {/* Welcome Section */}
        <div className="row mb-5">
          <div className="col-lg-12">
            <h1 className="h3 mb-3 fw-bold text-dark">Dashboard Overview</h1>
            
            {lastProject.name ? (
              <div className="card border-0 shadow-sm border-start border-5 border-success">
                <div className="card-body p-4 d-flex flex-column flex-md-row align-items-md-center justify-content-between">
                  <div>
                    <h5 className="card-title text-success mb-1">
                      <span className="badge bg-success me-2">Active Session</span>
                      Resuming: {lastProject.name}
                    </h5>
                    <p className="card-text text-muted mb-0 mt-2">
                       <span className="me-3 d-inline-flex align-items-center gap-2">
                         <Icons.Project /> Location: <strong>{lastProject.name}</strong>
                       </span>
                       <span className="d-inline-flex align-items-center gap-2">
                         <Icons.Calendar /> Survey: <strong>{formatSurveyLabel(lastProject.date)}</strong>
                       </span>
                    </p>
                  </div>
                  <div className="mt-3 mt-md-0">
                    {/* UPDATED: Uses handleResume to generate correct URL */}
                    <button onClick={handleResume} className="btn btn-success px-4 fw-bold">
                      Continue to Map
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <div className="card border-0 shadow-sm border-start border-5 border-warning">
                <div className="card-body p-4">
                  <h5 className="card-title text-warning">No Project Selected</h5>
                  <p className="text-muted">You haven't selected a survey location yet.</p>
                  <button className="btn btn-primary" onClick={() => navigate("/DataManagement")}>
                    Select a Project
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* System Modules Grid */}
        <div className="row">
          <div className="col-12 mb-3">
             <h5 className="text-muted text-uppercase small fw-bold ls-1">Available Modules</h5>
          </div>
        </div>

        <div className="row g-4">
          <div className="col-md-6 col-lg-3">
            <div className="card h-100 border-0 shadow-sm hover-shadow transition">
              <div className="card-body p-4 text-center">
                <div className="d-inline-block p-3 rounded-circle bg-success bg-opacity-10 text-success mb-3">
                  <Icons.Ndvi />
                </div>
                <h6 className="fw-bold">Vegetation Analysis</h6>
                <p className="small text-muted mb-0">NDVI filtering from -1.0 to 0.93 to assess plant health.</p>
              </div>
            </div>
          </div>

          <div className="col-md-6 col-lg-3">
             <div className="card h-100 border-0 shadow-sm hover-shadow transition">
              <div className="card-body p-4 text-center">
                <div className="d-inline-block p-3 rounded-circle bg-primary bg-opacity-10 text-primary mb-3">
                  <Icons.Lidar />
                </div>
                <h6 className="fw-bold">LiDAR & Point Cloud</h6>
                <p className="small text-muted mb-0">Visualize dense point clouds and 3D terrain models.</p>
              </div>
            </div>
          </div>

          <div className="col-md-6 col-lg-3">
             <div className="card h-100 border-0 shadow-sm hover-shadow transition">
              <div className="card-body p-4 text-center">
                <div className="d-inline-block p-3 rounded-circle bg-info bg-opacity-10 text-info mb-3">
                  <Icons.Cube />
                </div>
                <h6 className="fw-bold">3D Models</h6>
                <p className="small text-muted mb-0">Interact with mesh layers and 3D spatial data.</p>
              </div>
            </div>
          </div>

          <div className="col-md-6 col-lg-3">
             <div className="card h-100 border-0 shadow-sm hover-shadow transition">
              <div className="card-body p-4 text-center">
                <div className="d-inline-block p-3 rounded-circle bg-warning bg-opacity-10 text-warning mb-3">
                  <Icons.Camera />
                </div>
                <h6 className="fw-bold">Ground Truth</h6>
                <p className="small text-muted mb-0">Manage and verify site photos and localized imagery.</p>
              </div>
            </div>
          </div>
        </div>

        {/* Profile Summary */}
        <div className="row mt-5">
           <div className="col-md-6">
              <div className="card border-0 shadow-sm">
                <div className="card-header bg-white fw-bold py-3">
                   Account Summary
                </div>
                <ul className="list-group list-group-flush">
                   <li className="list-group-item d-flex justify-content-between align-items-center">
                      <span className="text-muted small">Full Name</span>
                      <span className="fw-bold">{info.name}</span>
                   </li>
                   <li className="list-group-item d-flex justify-content-between align-items-center">
                      <span className="text-muted small">Organization</span>
                      <span>{info.organization || "N/A"}</span>
                   </li>
                   <li className="list-group-item d-flex justify-content-between align-items-center">
                      <span className="text-muted small">Role</span>
                      <span className="badge bg-secondary">{info.role || "Viewer"}</span>
                   </li>
                </ul>
              </div>
           </div>
           
           <div className="col-md-6 mt-4 mt-md-0">
             <div className="p-4 bg-light border rounded h-100 d-flex flex-column justify-content-center align-items-start">
                <h5 className="mb-2">Need to switch projects?</h5>
                <p className="text-muted small">
                  Your current session is tied to <strong>{lastProject.name || "Unknown Location"}</strong>. 
                  Navigate to the management page to load a new survey set.
                </p>
                <a href="/DataManagement" className="btn btn-outline-dark btn-sm">Manage Data Layers</a>
             </div>
           </div>
        </div>

      </main>
    </div>
  );
}

export default Homepage;